import { useQuery } from '@tanstack/react-query';
import { policyDependencyService } from '@/services/leave/policyDependencyService';
import { leaveQueryKeys } from './queryKeys';

export const usePolicyDependencies = (policyId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: leaveQueryKeys.policyDependencies(policyId),
    queryFn: () => policyDependencyService.checkPolicyDependencies(policyId),
    enabled: enabled && !!policyId,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};